export const SVG_SCALE_REGEX = /scale\(([^,\s)]+),?\s*([^\s)]+)?\)/;
export const SVG_ROTATE_REGEX = /rotate\(([^,\s)]+),?\s*([^,\s)]+)?,?\s*([^,\s)]+)?\)/;
